// extracted by mini-css-extract-plugin
export default {"applicationNumber":"ModalApplicationNumbers_applicationNumber__5xEWv","applicationNumberLink":"ModalApplicationNumbers_applicationNumberLink__iuCcB"};